module.exports = __webpack_public_path__ + "static/media/plaid_aca_example.40a880d3.png";